import { UrlMatcher, UrlSegment } from '@angular/router';

/**
 * Matches when the first URL segment is one of `paths`, but consumes nothing
 * so the lazy-loaded feature module keeps its existing child paths
 * (e.g. module route `messDetails` still resolves as `/messDetails`).
 */
export function pathsMatcher(paths: string[]): UrlMatcher {
  const set = new Set(paths);
  return (segments: UrlSegment[]) => {
    if (!segments.length || !set.has(segments[0].path)) {
      return null;
    }
    return { consumed: [] };
  };
}
